import FormWrapper from '@components/search/forms/FormWrapper'
import ToolForm from '@components/search/forms/ToolForm'
import { frontpageLinks } from '@components/search/formLinks'

const ToolSearchpageForm = ({ query }) => {
    return (
        <FormWrapper
            Form={ToolForm}
            formLinks={frontpageLinks}
            overrideDefaultValues={query}
            active={7}
            linksOnTop
        />
    )
}

export default ToolSearchpageForm